module.exports = __webpack_public_path__ + "static/media/iconfont.544b6bdd.ttf";